import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-wizy-divider',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './divider.component.html',
    styleUrl: './divider.component.scss',
})
export class DividerComponent {
    @Input() vertical: boolean = false;
    @Input() inset: boolean = false;
    //Permet de modifier les marges directement depuis l'input si pas renseigné prends les marges du scss
    @Input() marginTop?: string;
    @Input() marginBottom?: string;
}
